module.exports = {"id":"227790","name":"Jeong Seung Hyun","rating":"71","photo":"./data/images/photos/2/227790.png","club":{"name":"Sagan Tosu","logo":"./data/images/clubs/SaganTosu.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JeongSeungHyun0.json
// module id = 1979
// module chunks = 0